/* eslint-disable @typescript-eslint/no-unused-vars */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    dialogHeaderId: function() {
        return dialogHeaderId;
    },
    hjelpetekstId: function() {
        return hjelpetekstId;
    },
    synonymId: function() {
        return synonymId;
    },
    kodelisteId: function() {
        return kodelisteId;
    },
    egendefinertKodelisteId: function() {
        return egendefinertKodelisteId;
    },
    egendefinertId: function() {
        return egendefinertId;
    },
    headerId: function() {
        return headerId;
    },
    subheaderId: function() {
        return subheaderId;
    },
    flervalgId: function() {
        return flervalgId;
    },
    slettKnappId: function() {
        return slettKnappId;
    },
    endreKnappId: function() {
        return endreKnappId;
    },
    leggtilKnappId: function() {
        return leggtilKnappId;
    },
    beskrivelseId: function() {
        return beskrivelseId;
    },
    kortgruppeSubHeaderId: function() {
        return kortgruppeSubHeaderId;
    },
    temaHeaderId: function() {
        return temaHeaderId;
    },
    kortgruppeHeaderId: function() {
        return kortgruppeHeaderId;
    },
    ledetekstId: function() {
        return ledetekstId;
    },
    oppsummeringsTekstId: function() {
        return oppsummeringsTekstId;
    },
    feltGruppeId: function() {
        return feltGruppeId;
    },
    dynamiskGruppeId: function() {
        return dynamiskGruppeId;
    },
    repeterendeFeltId: function() {
        return repeterendeFeltId;
    },
    dynamiskFeltId: function() {
        return dynamiskFeltId;
    },
    flereopplysningerId: function() {
        return flereopplysningerId;
    },
    skvisOverskriftId: function() {
        return skvisOverskriftId;
    },
    skvisLedetekstId: function() {
        return skvisLedetekstId;
    },
    beregnetskattOverskriftId: function() {
        return beregnetskattOverskriftId;
    },
    beregnetskattLedetekstId: function() {
        return beregnetskattLedetekstId;
    },
    naeringssammendragOverskriftId: function() {
        return naeringssammendragOverskriftId;
    },
    naeringssammendragId: function() {
        return naeringssammendragId;
    },
    beloepSomOverfoeresTilSkattemeldingenOverskriftId: function() {
        return beloepSomOverfoeresTilSkattemeldingenOverskriftId;
    },
    beloepSomOverfoeresTilSkattemeldingenId: function() {
        return beloepSomOverfoeresTilSkattemeldingenId;
    }
});
var identity = function(id) {
    return id;
};
var dialogHeaderId = function(id) {
    return id.replace("dialogheaders.", "");
};
var hjelpetekstId = function(id) {
    return "hjelpetekst.".concat(id);
};
var synonymId = function(id) {
    return "".concat(id);
};
var kodelisteId = function(id) {
    return "kodeliste.".concat(id);
};
var egendefinertKodelisteId = function(id) {
    return kodelisteId("Egendefinert.".concat(id));
};
var egendefinertId = function(id) {
    return id.replace("egendefinert.", "Egendefinert.");
};
var headerId = function(id) {
    return "header.".concat(id);
};
var subheaderId = function(id) {
    return "subheader.".concat(id);
};
var flervalgId = function(id) {
    return "flervalg.".concat(id);
};
var slettKnappId = function(id) {
    return "slettknapptekst.".concat(id);
};
var endreKnappId = function(id) {
    return "endreknapptekst.".concat(id);
};
var leggtilKnappId = function(id) {
    return "leggtilknapp.".concat(id);
};
var beskrivelseId = function(id) {
    return "beskrivelse.".concat(id);
};
var kortgruppeSubHeaderId = function(id) {
    return "kortgruppesubheaders.".concat(id);
};
var temaHeaderId = function(id) {
    return id.replace("temaheaders.", "");
};
var kortgruppeHeaderId = function(id) {
    return id.replace("kortgruppeheaders.", "");
};
var ledetekstId = function(id) {
    return id.replace("ledetekst.", "");
};
var oppsummeringsTekstId = function(id) {
    return id.replace("oppsummeringstekster.", "");
};
var feltGruppeId = function(id) {
    return id.replace("feltgruppe.", "");
};
var dynamiskGruppeId = function(id) {
    return id.replace("dynamiskgruppe.", "");
};
var repeterendeFeltId = function(id) {
    return id.replace("repeterendefelt.", "");
};
var dynamiskFeltId = function(id) {
    return id.replace("dynamiskfelt.", "");
};
var flereopplysningerId = function(id, type) {
    return "flereopplysninger.".concat(type, ".").concat(id);
};
var skvisOverskriftId = function(id, svalbard) {
    return "skvisoverskrift.".concat(id).concat(svalbard ? ".svalbard" : "");
};
var skvisLedetekstId = function(id) {
    return id.replace("skvis.", "");
};
var beregnetskattOverskriftId = function(id) {
    return "skatteberegningoverskrift.".concat(id);
};
var beregnetskattLedetekstId = function(id) {
    return id.replace("skatteberegning.", "");
};
var naeringssammendragOverskriftId = function(id) {
    return "naeringssammendragoverskrift.".concat(id);
};
var naeringssammendragId = function(id) {
    return id.replace("naeringssammendrag.", "");
};
var beloepSomOverfoeresTilSkattemeldingenOverskriftId = function(id) {
    return "overfoerestilskattemeldingoverskrift.".concat(id);
};
var beloepSomOverfoeresTilSkattemeldingenId = function(id) {
    return "overfoerestilskattemelding.".concat(id);
};
